<script setup>
defineProps({
  ambiti: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div class="in-servizi-end-page-section row-40-20 p-top-7 max">
    <div class="row-80">
      <div class="container">
        <div class="left-section">
          <h2 class="heading-3">
            Entriamo nel cuore di ogni azienda e risolviamo le specifiche
            necessità di ogni funzione.
          </h2>
          <div v-if="ambiti.length > 0" class="text-2">
            <ul class="list">
              <li
                v-for="(item, index) in ambiti"
                :key="index"
                class="ambito"
                :class="{ 'last-element': index === ambiti.length - 1 }"
              >
                <nuxt-link
                  v-if="item.slug"
                  class="text-3"
                  :to="
                    $localePath({
                      name: 'ambiti-slug',
                      params: { slug: item.slug },
                    })
                  "
                >
                  <div v-if="item.titolo" class="icon-link-animation">
                    {{ item.titolo }}
                    <img
                      src="@/assets/img/ico/arrows.svg"
                      alt="Icon"
                      class="icon"
                    />
                  </div>
                </nuxt-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="right-section">
          <div class="partner">
            <h2 class="heading-3">
              Per system integrator, software house, studi consulenziali e
              professionali.
            </h2>
            <p class="text-2 testo">
              Collaboriamo con aziende di software e servizi per migliorare
              l’efficienza digitale delle imprese, fornendo competenze
              qualificate verso gli obiettivi stabiliti.
            </p>
            <div class="end-page-btn">
              <MainButton
                text="Diventa partner"
                url="/partner"
                :internal-link="true"
                :is-black="false"
                :is-blue="true"
              />
            </div>
          </div>
          <div class="nl">
            <!--<h2 class="heading-3">
              È il modo in cui si usano le informazioni a fare la differenza.
            </h2>-->
            <p class="text-2 testo">
              Rimani sempre informato su normative, dati e ultime novità del
              mondo della trasformazione digitale.
            </p>
            <div class="end-page-btn">
              <MainButton
                text="Iscriviti alla Newsletter"
                url="https://5b83cd75.sibforms.com/serve/MUIFABE9Y6LINspLSCb1viJLEr4WPo4s-X2lYMa27HcGmN5CQY08iSl6B1nAFB64jNJ_-hopWUnyU4v3RFeDnZJaW6EhXHMKNRDbuUCNM5NMdcpqmfTHwg3nCOjTUlEOLOUwTtzLw450HJ0Xp43lFhw04O4G6rFLRTkXlynlcIe569eYvaSrQ85c1LZxadzBEK5w3vW-cOc09KQx"
                :internal-link="false"
                :is-black="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiziEndPageSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
